import { render, staticRenderFns } from "./courseGoodsList.vue?vue&type=template&id=186a51b3&scoped=true&"
import script from "./courseGoodsList.vue?vue&type=script&lang=js&"
export * from "./courseGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./courseGoodsList.vue?vue&type=style&index=0&id=186a51b3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a51b3",
  null
  
)

export default component.exports